import { useMutation } from '@tanstack/vue-query'
import { useStore } from 'vuex'
import OrganisationManagementService from '@/services/OrganisationManagementService'


/** Remove user from organisation params */
interface RemoveUserParams {
  organisationId: string
}

/**
 * Mutation hook for organisation operations
 */
export function useOrganisationsMutation() {
  const store = useStore()

  const {
    isPending: isRemovingUserFromOrganisationLoading,
    isSuccess: isRemovingUserFromOrganisationSuccess,
    isError: isRemovingUserFromOrganisationError,
    mutate: removeUserFromOrganisation,
  } = useMutation({
    mutationFn: ({ organisationId }: RemoveUserParams) => 
      OrganisationManagementService.removeUserFromOrganisation({ organisationId: String(organisationId) }),
    onSuccess: () => {
      store.dispatch('session/getOrganisationsList')
    },
  })

  return {
    isRemovingUserFromOrganisationLoading,
    isRemovingUserFromOrganisationSuccess,
    isRemovingUserFromOrganisationError,
    removeUserFromOrganisation,
  }
}